import {Box, Typography} from "@mui/material"
import styles from "./styles"
import {ButtonUI} from "../../../ui"
import {useDispatch} from "react-redux";
import {deleteCustomField} from "../../../../app/slices/field";
import React from "react";
import {useTranslation} from "react-i18next";

interface Props {
  setOpenModal: (openModal: boolean) => void,
  fieldIndex: number,
  productId: string | undefined,
  setUpdateFields: React.Dispatch<React.SetStateAction<boolean>>
}
const DeleteField = ({ setOpenModal, fieldIndex,productId, setUpdateFields}: Props) => {
  const dispatch = useDispatch();

  const { t } = useTranslation()
  
  const submitDeleteField = async () => {
    try {
      // @ts-ignore
      await dispatch(deleteCustomField({product_id: productId, index: fieldIndex}))
          .finally(() => setUpdateFields(true))

    } catch(error){
      console.log(error)
    }

  }

  return (
      <Box
        sx={styles.container}
        onClick={(e) => {e.stopPropagation()}}
      >

        <Box sx={styles.header}>
          <Typography variant="h6">{t("delete_field_modal.title")}</Typography>
          <img
              src='/assets/icons/modal_close.svg'
              onClick={() => setOpenModal(false)}
              style={{cursor: 'pointer'}}
              alt={''}
          />
        </Box>

        <Box sx={{ display: "flex",width:'100%',height: '100%', justifyContent:'center',alignItems:'center'}}>
         <Typography
             sx={{
               fontSize: '1.5rem',
               color: '#5F5F5F'
             }}
         >
           {t("delete_field_modal.subtitle")}
         </Typography>
        </Box>

        <Box sx={styles.buttons}>
          <ButtonUI
            type="outline"
            text={t("cancel")}
            onClick={() => setOpenModal(false)}
            width="123px"
          />

          <ButtonUI
            type="default"
            text={t("delete")}
            onClick={() => {
              submitDeleteField()
              setOpenModal(false)
            }}
            width="123px"
          />
        </Box>
      </Box>
  )
}

export default DeleteField